import {GatewayEditor} from "./GatewayEditor";

export class OrGatewayEditor extends GatewayEditor {
	constructor(parent, node, coords) {
		super(parent, node, coords);
	}

	drawTypeSymbol(ctx, rect) {
		ctx.save();
		ctx.lineWidth = 3 * this.lineWidth;

		ctx.strokeStyle=this.typeColor;
		ctx.beginPath();
		ctx.ellipse(rect.left + rect.width / 2, rect.top + rect.height / 2, rect.width / 4, rect.height / 4, 0, 0, 2 * Math.PI);
		ctx.stroke();

		ctx.restore();
	}
}